/** Shared helpers for the Intake prototype pages. */

/** Human-readable byte size (B / KB / MB). */
export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** Collision-resistant client-side id for mock records/events. */
export const newId = (): string =>
  `x-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
